import { pluralize, snakeToTitleCase } from 'lib/helpers/utility';

const stripSuffix = (source) => String(source).replace(/_(queue|table|list)$/i, '');

export const getExportLabel = ({ title, name }) => {
  const source = title || name;
  if (!source) return '';

  const words = snakeToTitleCase(stripSuffix(source)).trim().split(' ');
  const last = words.pop();

  if (!last || last.toLowerCase().endsWith('s')) return [...words, last].join(' ');

  return [...words, pluralize(last, 2)].join(' ');
};
